import { render, staticRenderFns } from "./ReferenceCommentListTabSelector.vue?vue&type=template&id=8ff24846&scoped=true&"
import script from "./ReferenceCommentListTabSelector.vue?vue&type=script&lang=ts&"
export * from "./ReferenceCommentListTabSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceCommentListTabSelector.vue?vue&type=style&index=0&id=8ff24846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff24846",
  null
  
)

export default component.exports